import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyAssortmentGroupChanges } from '../api/applyAssortmentGroupChanges'
import { REQUEST_SAVE_ASSORTMENT_GROUP } from '../constants'

export const requestSaveAssortmentGroup = createAsyncThunk(
  REQUEST_SAVE_ASSORTMENT_GROUP,
  applyAssortmentGroupChanges
)
